var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuditAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5976 3.50294C15.1834 3.40959 12.2585 0.982519 11.5117 0.266844C11.3372 0.0958041 11.1026 0 10.8582 0C10.6139 0 10.3793 0.0958041 10.2048 0.266844C9.458 1.01363 6.53307 3.40959 1.11883 3.53405C0.87669 3.54213 0.647171 3.64403 0.478782 3.81823C0.310393 3.99242 0.216327 4.22526 0.216461 4.46754V11.3442C0.216461 16.1673 2.3946 20.7414 6.00409 23.5729C7.36583 24.6575 8.91669 25.4804 10.5782 26H11.1383C12.7998 25.4804 14.3506 24.6575 15.7124 23.5729C19.3219 20.7414 21.5 16.1673 21.5 11.3442V4.43642C21.5001 4.19415 21.4061 3.96131 21.2377 3.78711C21.0693 3.61292 20.8398 3.51101 20.5976 3.50294Z",
    fill: "#7043FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditAmount);
export default __webpack_public_path__ + "static/media/audit_amount.e1a2f1c356f292e0f0fb5df56ed207fa.svg";
export { ForwardRef as ReactComponent };